import { HttpContext, HttpContextToken, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { NotificationToastService } from '../services/notification-toast.service';

/**
 * Token à poser sur une requête pour désactiver le toast de succès automatique
 * (quand le composant gère déjà son propre feedback utilisateur).
 */
export const SUPPRESS_SUCCESS_TOAST = new HttpContextToken(() => false);

/**
 * Contexte à passer aux méthodes des services qui affichent déjà leur propre
 * message de succès local, afin d'éviter un double feedback.
 */
export const SUPPRESS_SUCCESS_CONTEXT = new HttpContext().set(SUPPRESS_SUCCESS_TOAST, true);

const MUTATIONS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export const successToastInterceptor: HttpInterceptorFn = (req, next) => {
  if (!MUTATIONS.has(req.method) || req.context.get(SUPPRESS_SUCCESS_TOAST)) {
    return next(req);
  }

  const toastService = inject(NotificationToastService);

  return next(req).pipe(
    map((event) => {
      if (event instanceof HttpResponse && event.status >= 200 && event.status < 300) {
        toastService.showSuccess('Opération effectuée avec succès.');
      }
      return event;
    }),
  );
};
